import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {IntFilterSelectComponent} from "./int-filter-select.component";
import {IntInputModule} from "../../int-input/int-input.module";
import {IntPortalSlotModule} from "../../../modules/portal-slot";
import {IntAttrBindingModule, IntInsertAfterViewInitModule} from "../../../directives";
import {IntDropdownChevronModule} from "../../chanks";
import {IntDefaultInputModule} from "../int-default-input";
import {IntDropdownAreaModule} from "../../dropdowns";


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IntInputModule,
    IntPortalSlotModule,
    IntInsertAfterViewInitModule,
    IntDropdownChevronModule,
    IntDefaultInputModule,
    IntDropdownAreaModule,
    IntAttrBindingModule
  ],
  declarations: [IntFilterSelectComponent],
  exports: [IntFilterSelectComponent]
})
export class IntFilterSelectModule {}
